import { api } from "@/api/client";
import type {
  IntercompanyCapabilities,
  IntercompanyPairCreate,
  IntercompanyPairView,
  ReconActionRequest,
  ReconActionResult,
  ReconBatchResult,
  ReconResult,
} from "@/types/api";

export async function getIntercompanyCapabilities(): Promise<IntercompanyCapabilities> {
  const { data } = await api.get<IntercompanyCapabilities>("/intercompany/capabilities");
  return data;
}

export async function listIntercompanyPairs(): Promise<IntercompanyPairView[]> {
  const { data } = await api.get<IntercompanyPairView[]>("/intercompany/pairs");
  return data;
}

export async function createIntercompanyPair(
  body: IntercompanyPairCreate,
): Promise<IntercompanyPairView> {
  const { data } = await api.post<IntercompanyPairView>("/intercompany/pairs", body);
  return data;
}

export async function updateIntercompanyPair(
  id: string,
  body: IntercompanyPairCreate,
): Promise<IntercompanyPairView> {
  const { data } = await api.put<IntercompanyPairView>(`/intercompany/pairs/${id}`, body);
  return data;
}

export async function deleteIntercompanyPair(id: string): Promise<void> {
  await api.delete(`/intercompany/pairs/${id}`);
}

export async function reconcileIntercompany(
  pairId: string,
  range?: { dateFrom?: string; dateTo?: string },
): Promise<ReconResult> {
  const params: Record<string, string> = {};
  if (range?.dateFrom) params.date_from = range.dateFrom;
  if (range?.dateTo) params.date_to = range.dateTo;
  const { data } = await api.post<ReconResult>(
    `/intercompany/pairs/${pairId}/reconcile`,
    null,
    { params },
  );
  return data;
}

export async function runIntercompanyAction(
  pairId: string,
  req: ReconActionRequest,
): Promise<ReconActionResult> {
  const path =
    req.kind === "create_sf"
      ? `/intercompany/pairs/${pairId}/actions/create-sf`
      : `/intercompany/pairs/${pairId}/actions/mark-delete`;
  const { data } = await api.post<ReconActionResult>(path, req);
  return data;
}

export async function runIntercompanyBatch(
  pairId: string,
  actions: ReconActionRequest[],
): Promise<ReconBatchResult> {
  const { data } = await api.post<ReconBatchResult>(
    `/intercompany/pairs/${pairId}/actions/batch`,
    { actions },
  );
  return data;
}
